// src/menuConfig.js
import PizzaGenerator2 from "./components/PizzaGenerator2";

const menuConfig = [
    { label: 'Pizza', link: '/' , component: PizzaGenerator2},
    // Weitere Menüpunkte hier hinzufügen
];

export default menuConfig;
